module.exports = __webpack_public_path__ + "assets/img/logo_visa.a58a8d1d.svg";